import axios from 'axios'
import api from '../../api/api'
import url from '../../api/env'
import Utils from '../../utils/Utils'

const getPlatformSettings = async () =>
  api
    .get(url.stage.platformSettings, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

// Para usar ANTES de iniciar sesión (pantalla de Login): api.js intenta
// refrescar el token en cada petición, y eso revienta cuando todavía no
// existe ninguna sesión guardada en localStorage (JSON.parse(null).token).
// Esta ruta es pública en el backend a propósito, así que acá se pide
// directo con axios, sin pasar por esa lógica de sesión.
const getPlatformSettingsPublic = async () =>
  axios
    .get(url.stage.platformSettings)
    .then(res => res.data)
    .catch(err => {
      console.log(err)
      return null
    })

const updatePlatformSettings = async data =>
  api
    .put(url.stage.platformSettings, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
  getPlatformSettings,
  getPlatformSettingsPublic,
  updatePlatformSettings,
}
